import { render, staticRenderFns } from "./ModalItemForm.vue?vue&type=template&id=1133e5fa"
import script from "./ModalItemForm.vue?vue&type=script&lang=js"
export * from "./ModalItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports